import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import AxiosPlugin from './plugins/axios'

Vue.config.productionTip = false

Vue.use(AxiosPlugin)

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
